
export const authTypes = {
    login: "LOGIN",
    logout: "LOGOUT",
    refresh: "REFRESH",    
}